var render, staticRenderFns
import script from "./SWCarousel.vue?vue&type=script&lang=js&"
export * from "./SWCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/sw-41f73918-1793878079/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15accec7')) {
      api.createRecord('15accec7', component.options)
    } else {
      api.reload('15accec7', component.options)
    }
    
  }
}
component.options.__file = "www/roadrunner/Application/ViewComponents/Carousel/SWCarousel.vue"
export default component.exports